export enum BUTTON_SIZE {
    SMALL = 'small',
    DEFAULT = 'medium',
}
